import DefaultCellRenderers from '@entity/EntityTable/CellRenderers';

// We can import additional Components here to expand or overwrite Boilerplate Components
const CellRenderers = {
  ...DefaultCellRenderers,
};

export default CellRenderers;
